import { ExportParameter } from "app/Model/exportParameter/ExportParameter";

export class WorkflowItem
{
  constructor(
    public order?: number,
    public workflowItemType?: string,
    public jobType?: string,
    public macroParameter?: string,
    public macroName?: string,
    public fTPServerId?: string,
    public excelTemplateId?: string,
    public exportParameterId?: string,
    public ftpServerPath?: string,
    public ftpServerRecursivePath?: boolean,
    public exportParameter?: ExportParameter,
  ) { }

}
